import Swal from 'sweetalert2';

export const showDeleteConfirmation = ({
  title = 'Delete Item?',
  text = 'Are you sure you want to delete this item?',
  itemName = '',
  onConfirm,
  onCancel = null
}) => {
  return Swal.fire({
    title,
    html: `
      <div class="text-center">
        <div class="mb-3">
          <i class="fas fa-exclamation-triangle fa-3x text-warning"></i>
        </div>
        <h5 class="fw-semibold mb-2">Are you sure?</h5>
        <p class="text-muted mb-0">
          ${text}${itemName ? ` <strong class="text-dark">"${itemName}"</strong>` : ''}
          <br>This action cannot be undone.
        </p>
      </div>
    `,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#6c757d',
    confirmButtonText: '<i class="fas fa-trash me-2"></i>Yes, delete it!',
    cancelButtonText: '<i class="fas fa-times me-2"></i>Cancel',
    backdrop: 'rgba(0,0,0,0.4)',
    customClass: {
      confirmButton: 'fw-semibold',
      cancelButton: 'fw-semibold'
    }
  }).then((result) => {
    if (result.isConfirmed && onConfirm) {
      onConfirm();
    } else if (result.isDismissed && onCancel) {
      onCancel();
    }
  });
};

export const showSuccessAlert = (message = 'Operation completed successfully!') => {
  return Swal.fire({
    icon: 'success',
    title: 'Success!',
    text: message,
    timer: 2000,
    showConfirmButton: false,
    toast: true,
    position: 'top-end'
  });
};

export const showErrorAlert = (message = 'Something went wrong!') => {
  return Swal.fire({
    icon: 'error',
    title: 'Error!',
    text: message,
    confirmButtonColor: '#d33'
  });
};